import { FC } from 'react';
import classnames from 'classnames';

import IFramedPromoPartnershipStartShoppingCta from './IFramedPromoPartnershipStartShoppingCta';

import sharedStyles from './styles/shared.scss';

const IFramedPromoPartnershipNoPromoCode: FC = () => (
    <div className={classnames(sharedStyles.wrapper, sharedStyles.wrapperSpacing)}>
        <IFramedPromoPartnershipStartShoppingCta />
    </div>
);

export default IFramedPromoPartnershipNoPromoCode;
